import styled from 'styled-components';

export const InputWrapper = styled.div`
	width: 100%;
`;

export const InputContainer = styled.div<{ $disabled: boolean }>`
	position: relative;
	width: 100%;

	.currency-select {
		position: absolute;
		left: 8px;
		top: 50%;
		transform: translateY(-50%);
		z-index: 2;
		width: 52px;
		${({ $disabled }) => `
			cursor: ${$disabled ? 'default' : 'pointer'};
		`}

		.mantine-Select-wrapper {
			.mantine-Input-rightSection {
				right: -0.25rem;
			}
		}

		.mantine-Select-input {
			border: none;
			background: transparent;
			margin: 0;
			padding: 0 20px 0 0;
			height: auto;
			min-height: auto;
			cursor: pointer;

			&:focus {
				border: none;
				box-shadow: none;
			}
		}

		.mantine-Select-rightSection {
			display: flex;
			right: 0;
			pointer-events: none;
			margin-left: 0.5rem;
		}
	}

	.amount-input {
		.mantine-TextInput-input {
			padding-left: 56px;
			text-align: right;
		}
	}
`;
